<script setup lang="ts">
import { ref, computed, onMounted } from "vue";
import allCountries from "country-calling-code";
import { useToast } from "primevue/usetoast";
import Toast from "primevue/toast";
import InputText from "primevue/inputtext";
import Select from "primevue/select";
import Textarea from "primevue/textarea";
import FileUpload from "primevue/fileupload";
const isUploading = ref(false);
const uploadProgress = ref(0);
const toast = useToast();
const config = useRuntimeConfig();
const baseURL = config.public.baseUrl;
const emailPattern =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,})$/i;

const namePattern = /^[^a-zA-Z]*[a-zA-Z].*$/;
// Enhanced phone pattern - only digits allowed, no 'e' or other characters
const phonePattern = /^\d+$/;

const initialFormState = () => ({
  contact: {
    name: "",
    email: "",
    mobile: "",
    service: null,
    budget: "",
  },
  lead: {
    message: null,
    source: null,
    title: null,
    bd_department_id: 1,
  },
  email: {
    bd_inbox_id: 1,
  },
  uploaded_files: [] as any[],
  is_checked: [] as string[],
  subject: null,
  description: "",
  country_code: "+91",
  country: "India",
  phone_prefix: "+91",
  default_country_code: "IN",
  budget_warning: null,
});

const form = ref(initialFormState());

const countryCode = ref("India");

const errors = ref({
  name: "",
  email: "",
  mobile: "",
  service: "",
  description: "",
});

const countriesData = computed(() => allCountries ?? []);

const countryCodes = allCountries?.map((c: any) => ({
  name: c.country,
  code: `+${c.countryCodes[0]}`,
  isoCode: c.isoCode2,
}));

watch(
  () => countryCode.value,
  (newName) => {
    console.log(countryCode.value, "Manan");
    const selected = countryCodes.find((c) => c.name === newName);
    if (selected) {
      form.value.country_code = selected.code;
      form.value.country = selected.name;
      form.value.default_country_code = selected.isoCode;
    }
  }
);

const services = [
  { name: "Web Development", code: "Web Development" },
  { name: "Mobile App Development", code: "Mobile App Development" },
  { name: "UI/UX Design", code: "UI/UX Design" },
  { name: "Digital Marketing", code: "Digital Marketing" },
  { name: "Consulting", code: "Consulting" },
];

const emit = defineEmits(["formsubmitted"]);

const validateName = () => {
  errors.value.name = "";
  const name = form.value.contact.name?.trim() || "";
  if (!name) {
    errors.value.name = "Full name is required";
    return false;
  }
  if (!namePattern.test(name.toLowerCase())) {
    errors.value.name = "Invalid name format";
    return false;
  }
  return true;
};

const validateEmail = () => {
  errors.value.email = "";
  if (!form.value.contact.email) {
    errors.value.email = "Email is required";
    return false;
  }
  if (!emailPattern.test(form.value.contact.email.toLowerCase())) {
    errors.value.email = "Invalid email format";
    return false;
  }
  return true;
};

const sanitizePhoneInput = computed(() => {
  form.value.contact.mobile = form.value.contact.mobile.replace(/\D/g, "");
});

const validateMobile = () => {
  errors.value.mobile = "";
  if (!form.value.contact.mobile) {
    errors.value.mobile = "Phone number is required";
    return false;
  }

  // Check if input contains only digits (no 'e' or other characters)
  if (!phonePattern.test(form.value.contact.mobile)) {
    errors.value.mobile = "Phone number must contain only Numeric Value";
    return false;
  }

  const digits = form.value.contact.mobile.replace(/\D/g, "");

  if (digits.length < 8 || digits.length > 15) {
    errors.value.mobile = "Phone must be 8-15 Numeric Value";
    return false;
  }
  return true;
};

const validateService = () => {
  errors.value.service = "";
  if (!form.value.contact.service) {
    errors.value.service = "Service selection is required";
    return false;
  }
  return true;
};

const validateDescription = () => {
  errors.value.description = "";

  const desc = form.value.description?.trim() || "";

  if (!desc) {
    errors.value.description =
      "Project description is required, Enter a valid Description ";
    return false;
  }
  if (desc.length <= descriptionValidation.value) {
    errors.value.description = `Description must be at least ${descriptionValidation.value} characters`;
    return false;
  }
  return true;
};

const validateForm = () => {
  const validations = [
    validateName(),
    validateEmail(),
    validateMobile(),
    validateService(),
    validateDescription(),
  ];

  return validations.every((valid) => valid);
};

const onFormSubmit = async (e: any) => {
  e.preventDefault();
  e.stopPropagation();
  if (!validateForm()) {
    const firstError = Object.values(errors.value).find((msg) => msg);
    if (firstError) {
      toast.add({
        severity: "error",
        summary: "Validation Error",
        detail: firstError,
        life: 5000,
      });
    }
    return;
  }

  console.log("Form values:", form.value);
  let inputs = JSON.parse(JSON.stringify(form.value));

  inputs.lead.title = inputs.contact.name + " - " + inputs.country;
  inputs.contact.mobile = inputs.phone_prefix + " " + inputs.contact.mobile;
  inputs.lead.message =
    "<p><b>Requirement : </b>" + inputs.description + "</p>";
  if (inputs.uploaded_files.length > 0) {
    inputs.uploaded_files.forEach((file) => {
      inputs.lead.message += `<p><b>Documents : </b><a target="_blank" href="${file.full_url}">${file.original_name}</a></p>`;
    });
  }
  inputs.lead.message += "<p><b>Country : </b>" + inputs.country + "</p>";
  inputs.lead.message +=
    "<p><b>Page Url : </b>" + window.location.href + "</p>";
  inputs.lead.message +=
    "<p><b>Services : </b>" + inputs.contact.service + "</p>";
  inputs.lead.source = window.location.hostname;

  let params = inputs;

  console.log("params", params);

  let options = {
    method: "POST" as const,
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      "Api-Token": "qL?]_}q8jwUX",
      "sec-fetch-mode": "cors",
      "sec-fetch-site": "same-origin",
      Referer: `${baseURL}/contact-us`,
      Origin: `${baseURL}`,
      Authorization: "Bearer qL?]_}q8jwUX",
    },
    body: JSON.stringify(params),
  };

  let ajax_url = "/api/leads-add";

  try {
    const { data, error } = await $fetch(ajax_url, options);

    if (error) {
      toast.add({
        severity: "error",
        summary: "Error occurred",
        detail: error?.message || "Something went wrong",
        life: 5000,
      });
    } else {
      emit("formsubmitted", data);
      form.value = initialFormState();

      toast.add({
        severity: "success",
        summary: "Form Submitted",
        detail: "Your form has been submitted successfully!",
        life: 4000,
      });
    }
  } catch (err: any) {
    toast.add({
      severity: "error",
      summary: "Error occurred",
      detail: err.message || "Something went wrong",
      life: 5000,
    });
    console.log(err);
  }
};

const props = defineProps({
  layoutChange: {
    type: Boolean,
    default: false,
  },
  prefilledContent: {
    default: "",
  },
});

const descriptionValidation = computed(() =>
  props.prefilledContent.length ? 0 : 50
);

const prefilledText = computed(() => {
  const content = props.prefilledContent;

  if (typeof content === "string") {
    if (
      content.includes("Hire dedicated") ||
      content.includes("Hire part time") ||
      content.includes("I want to hire WebReinvent for") ||
      content.includes("I want to discuss about")
    ) {
      return content;
    }
    return "";
  }

  if (Array.isArray(content)) {
    if (content.length) {
      if ("selectedUpgradeFrom" in content[0]) {
        const formattedItems = content.map((item) => {
          const parts: string[] = [];

          if (item?.selectedUpgradeFrom?.label?.trim()) {
            parts.push(`From: ${item.selectedUpgradeFrom.label}`);
          }
          if (item?.selectedUpgradeTo?.label?.trim()) {
            parts.push(`To: ${item.selectedUpgradeTo.label}`);
          }

          return parts.join("\n");
        });

        if (formattedItems.length > 0) {
          return `I want to Upgrade\n${formattedItems.join("\n")}`;
        }
      } else {
        const hasRole = content.some((item) =>
          item?.selectedRole?.name?.trim()
        );

        const formattedItems = content
          .map((item) => {
            const parts: string[] = [];

            if (item?.selectedRole?.name?.trim()) {
              parts.push(`Role: ${item.selectedRole.name}`);
            }
            if (item?.selectedLevel?.name?.trim()) {
              parts.push(`Level: ${item.selectedLevel.name}`);
            }
            if (item?.selectedContract?.name?.trim()) {
              parts.push(`Contract: ${item.selectedContract.name}`);
            } else if (item?.yearsOfExp) {
              parts.push(`Experience: ${item.yearsOfExp} years`);
            }
            if (item?.quantity) {
              parts.push(`Quantity: ${item.quantity}`);
            }

            return parts.join(" | ");
          })
          .filter((line) => line.length > 0);

        if (formattedItems.length > 0) {
          // 👇 if no role found → fallback text
          if (!hasRole) {
            return `I want to hire developer(s)\n${formattedItems.join("\n")}`;
          }
          return `I want to hire \n${formattedItems.join("\n")}`;
        }
      }
    }
    return "";
  }

  return "";
});

const preFilledEmail = computed(() => {
  const content = props.prefilledContent;

  if (typeof content === "string") {
    return "";
  }
  if (props.prefilledContent?.length) {
    if ("businessEmail" in props.prefilledContent?.at(0))
      return props.prefilledContent?.at(0)?.businessEmail;
    return "";
  }
  return "";
});

const prefilledCode = computed(() => "+91");

// Set prefilled values when component mounts
onMounted(() => {
  if (preFilledEmail.value) {
    form.value.contact.email = preFilledEmail.value;
  }
  if (prefilledText.value) {
    form.value.description = prefilledText.value;
  }
  form.value.country_code = prefilledCode.value;
});

//---------------------------------------------------------------------

async function onFileSelect(event) {
  const file = event?.files[0];

  // Validate file type
  const allowedTypes = [
    "image/png",
    "image/jpeg",
    "image/jpg",
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "text/csv",
  ];

  if (!allowedTypes.includes(file?.type)) {
    toast.add({
      severity: "error",
      summary: "Invalid File",
      detail: "Only images, pdf, word, excel, csv are allowed",
      life: 4000,
    });
    return;
  }

  // Validate size (5 MB)
  if (file?.size > 5000000) {
    toast.add({
      severity: "error",
      summary: "File Too Large",
      detail: "Max size is 5 MB",
      life: 4000,
    });
    return;
  }

  // ✅ proceed with upload
  isUploading.value = true;
  uploadProgress.value = 0;

  const formData = new FormData();
  formData.append("file", file);
  formData.append("folder_path", "public/media");

  const xhr = new XMLHttpRequest();
  const alreadyExists = form.value.uploaded_files?.some(
    (f) => f?.original_name === file?.name
  );
  if (alreadyExists) {
    toast.add({
      severity: "warn",
      summary: "Already Uploaded",
      detail: `${file.name} has already been uploaded`,
      life: 3000,
    });
    return;
  }
  xhr.open("POST", "/api/leads-upload", true);

  xhr.upload.onprogress = (e) => {
    if (e.lengthComputable) {
      uploadProgress.value = Math.round((e.loaded * 100) / e.total);
    }
  };

  xhr.onload = () => {
    isUploading.value = false;
    if (xhr.status === 200) {
      const response = JSON.parse(xhr.responseText);

      // ✅ check if file with same name already exists

      // ✅ push only if new
      form.value.uploaded_files.push({
        original_name: file.name,
        full_url: response.data.full_url,
        size: file.size,
      });

      toast.add({
        severity: "success",
        summary: "Upload Successful",
        detail: `${file.name} uploaded successfully`,
        life: 3000,
      });
    }
  };

  xhr.onerror = () => {
    isUploading.value = false;
  };

  xhr.send(formData);
}

function removeFile(index: number) {
  form.value.uploaded_files.splice(index, 1);
}
</script>

<template>
  <div class="p-px bg-[image:var(--border-form)] !rounded-xl">
    <div
      class="grow lg:px-[3rem] px-[1rem] pt-5 pb-5 rounded-xl h-full relative"
      :class="
        props.layoutChange
          ? 'bg-white dark:bg-inherit '
          : 'bg-[image:var(--bg-form)]'
      "
    >
      <h3 class="font-normal text-2xl text-center mb-5">Get Your Free Quote</h3>
      <div class="card flex justify-center">
        <Toast class="!w-full !max-w-[340px]" />
        <form
          @submit.prevent="onFormSubmit"
          class="flex flex-col lg:gap-7 gap-6 w-full"
        >
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <!-- Name Field -->
            <div class="flex flex-col gap-1">
              <label for="fullName" class="text-base"
                >Full Name <span class="text-red-600 -ml-1">*</span></label
              >
              <InputText
                id="fullName"
                v-model="form.contact.name"
                type="text"
                placeholder="Full Name"
                class="w-full"
                :class="{ 'p-invalid': errors.name }"
                @blur="validateName"
                @input="errors.name = ''"
              />
              <small v-if="errors.name" class="text-red-500">{{
                errors.name
              }}</small>
            </div>

            <!-- Email Field -->
            <div class="flex flex-col gap-1">
              <label for="businessEmail" class="text-base">
                Business Email <span class="text-red-600 -ml-1">*</span></label
              >
              <InputText
                id="businessEmail"
                v-model="form.contact.email"
                type="text"
                placeholder="Business Email"
                class="w-full"
                :class="{ 'p-invalid': errors.email }"
                @blur="validateEmail"
                @input="errors.email = ''"
              />
              <small v-if="errors.email" class="text-red-500">{{
                errors.email
              }}</small>
            </div>

            <!-- Phone Field (shown when layoutChange is true) -->
            <div class="flex flex-col gap-1" v-if="props.layoutChange">
              <label for="phoneNumber" class="text-base"
                >Phone Number <span class="text-red-600">*</span></label
              >
              <div class="flex gap-2">
                <Select
                  v-model="countryCode"
                  :options="countryCodes"
                  option-label="name"
                  option-value="name"
                  placeholder="Country Code"
                  class="lg:w-32 w-24"
                />

                <div class="relative flex-1">
                  <span
                    class="absolute left-3 top-1/2 transform -translate-y-1/2"
                  >
                    {{ form.country_code }}
                  </span>
                  <InputText
                    id="phoneNumber"
                    v-model="form.contact.mobile"
                    type="tel"
                    placeholder=""
                    class="w-full !pl-16"
                    :class="{ 'p-invalid': errors.mobile }"
                    @blur="validateMobile"
                    @input="sanitizePhoneInput"
                    maxlength="15"
                    minlength="8"
                  />
                </div>
              </div>
              <small v-if="errors.mobile" class="text-red-500">{{
                errors.mobile
              }}</small>
            </div>

            <!-- Service Field (shown when layoutChange is true) -->
            <div
              class="flex flex-col gap-1 relative z-30"
              v-if="props.layoutChange"
            >
              <label for="interestedService" class="text-base"
                >Interested Services <span class="text-red-600">*</span></label
              >
              <Select
                id="interestedService"
                v-model="form.contact.service"
                :options="services"
                option-label="name"
                option-value="code"
                placeholder="Please select a service"
                class="w-full"
                :class="{ 'p-invalid': errors.service }"
                @blur="validateService"
                @change="errors.service = ''"
              />
              <small v-if="errors.service" class="text-red-500">{{
                errors.service
              }}</small>
            </div>

            <!-- Description Field (shown when layoutChange is true) -->
            <div class="flex flex-col gap-1" v-if="props.layoutChange">
              <label class="text-base"
                >Brief About Project <span class="text-red-600">*</span></label
              >
              <Textarea
                id="projectBrief"
                v-model="form.description"
                rows="2"
                placeholder="Brief about Project"
                class="w-full"
                :class="{ 'p-invalid': errors.description }"
                @blur="validateDescription"
                @input="errors.description = ''"
              />
              <small v-if="errors.description" class="text-red-500">{{
                errors.description
              }}</small>
            </div>

            <!-- File Upload (shown when layoutChange is true) -->
            <div class="flex flex-col gap-1" v-if="props.layoutChange">
              <label class="text-base" for="file"
                >If you have any file to share with us</label
              >
              <FileUpload
                name="file"
                mode="basic"
                multiple
                :auto="true"
                accept="image/*,application/pdf,.doc,.docx,.xls,.xlsm,.xlsx,.csv"
                :maxFileSize="5000000"
                chooseLabel="Drop File here"
                ref="fileUpload"
                @select="onFileSelect"
                customUpload
                unstyled
                :pt="{
                  root: {
                    class: `w-full px-3 py-3 !bg-[image:var(--p-fileinput-background)] dark:bg-[var(--p-fileinput-background)] text-base border border-[var(--border-input)] rounded focus:outline-none cursor-pointer flex flex-col gap-2 [&_div[aria-live='assertive']]:!hidden`,
                  },
                  basicContent: {
                    class:
                      'w-full *:flex *:flex-row-reverse *:justify-between gap-2 *:items-center',
                  },
                  input: { class: '!hidden' },
                  pcMessage: { class: '!hidden' },
                  chooseButton: {
                    class: 'w-full flex justify-between items-center',
                  },
                  pcChooseButton: { class: '!w-full' },
                }"
                class="w-full flex flex-col gap-2"
              >
                <template #chooseicon>
                  <NuxtImg
                    :src="
                      $colorMode.preference == 'dark'
                        ? '/images/darkDownloadIcon.webp'
                        : '/images/downloadIcon.webp'
                    "
                    height="15"
                    width="15"
                    class="ml-3"
                    loading="lazy"
                    format="webp"
                  />
                </template>
              </FileUpload>

              <!-- Upload Progress -->
              <div
                v-if="isUploading"
                class="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700"
              >
                <div
                  class="bg-[linear-gradient(95.99deg,#6C59B5_3.69%,#261640_96.65%)] h-2.5 rounded-full"
                  :style="{ width: uploadProgress + '%' }"
                ></div>
              </div>

              <!-- Uploaded Files -->
              <ul v-if="form.uploaded_files.length" class="mt-4 space-y-3">
                <li
                  v-for="(file, index) in form.uploaded_files"
                  :key="index"
                  class="group flex items-center justify-between p-4 bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg transition-colors duration-200"
                >
                  <div class="flex items-center space-x-3 flex-1 min-w-0">
                    <!-- File Icon -->
                    <div
                      class="flex-shrink-0 w-10 h-10 bg-blue-100 dark:bg-blue-900 rounded-lg flex items-center justify-center"
                    >
                      <svg
                        class="w-5 h-5 dark:text-white"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                        ></path>
                      </svg>
                    </div>

                    <!-- File Info -->
                    <div class="flex-1 min-w-0">
                      <a
                        :href="file.full_url"
                        target="_blank"
                        class="block text-sm font-medium text-gray-900 dark:text-gray-100 hover:text-blue-600 dark:hover:text-blue-400 truncate underline decoration-transparent hover:decoration-current transition-colors duration-200"
                      >
                        {{ file.original_name }}
                      </a>
                      <p class="text-xs text-gray-500 dark:text-gray-400 mt-1">
                        Click to view file
                      </p>
                    </div>
                  </div>

                  <!-- Remove Button -->
                  <button
                    type="button"
                    class="flex-shrink-0 ml-4 p-2 text-gray-400 hover:text-red-500 dark:text-gray-500 dark:hover:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-lg transition-all duration-200 group-hover:opacity-100 opacity-75"
                    @click="removeFile(index)"
                    title="Remove file"
                  >
                    <svg
                      class="w-4 h-4"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                      ></path>
                    </svg>
                  </button>
                </li>
              </ul>
            </div>
          </div>

          <!-- Phone Field (shown when layoutChange is false) -->
          <div class="flex flex-col gap-1" v-if="!props.layoutChange">
            <label for="phoneNumber" class="text-base"
              >Phone Number <span class="text-red-600">*</span></label
            >
            <div class="flex gap-2 xl:max-w-[70%]">
              <Select
                v-model="countryCode"
                :options="countryCodes"
                option-label="name"
                option-value="name"
                placeholder="Country Code"
                class="lg:w-32 w-24"
              />

              <div class="relative flex-1">
                <span
                  class="absolute left-3 top-1/2 transform -translate-y-1/2"
                >
                  {{ form.country_code }}
                </span>
                <InputText
                  id="phoneNumber"
                  v-model="form.contact.mobile"
                  type="tel"
                  placeholder=""
                  class="w-full !pl-12"
                  :class="[
                    { 'p-invalid': errors.mobile },
                    form.country_code.length > 3 ? '!pl-16' : '!pl-12',
                  ]"
                  @blur="validateMobile"
                  @input="sanitizePhoneInput"
                  maxlength="15"
                  minlength="8"
                />
              </div>
            </div>
            <small v-if="errors.mobile" class="text-red-500">{{
              errors.mobile
            }}</small>
          </div>

          <!-- Service Field (shown when layoutChange is false) -->
          <div
            class="flex flex-col gap-1 relative z-30"
            v-if="!props.layoutChange"
          >
            <label for="interestedService" class="text-base"
              >Interested Services <span class="text-red-600">*</span></label
            >
            <Select
              id="interestedService"
              v-model="form.contact.service"
              :options="services"
              option-label="name"
              option-value="code"
              placeholder="Please select a service"
              class="w-full"
              :class="{ 'p-invalid': errors.service }"
              @blur="validateService"
              @change="errors.service = ''"
            />
            <small v-if="errors.service" class="text-red-500">{{
              errors.service
            }}</small>
          </div>

          <!-- Description Field (shown when layoutChange is false) -->
          <div class="flex flex-col gap-1" v-if="!props.layoutChange">
            <label class="text-base"
              >Brief About Project <span class="text-red-600">*</span></label
            >
            <Textarea
              id="projectBrief"
              v-model="form.description"
              rows="3"
              placeholder="Brief about Project"
              class="w-full"
              :class="{ 'p-invalid': errors.description }"
              @blur="validateDescription"
              @input="errors.description = ''"
            />

            <small v-if="errors.description" class="text-red-500">{{
              errors.description
            }}</small>
          </div>

          <!-- File Upload (shown when layoutChange is false) -->
          <div class="flex flex-col gap-1" v-if="!props.layoutChange">
            <label class="text-base" for="file"
              >If you have any file to share with us</label
            >
            <FileUpload
              name="file"
              mode="basic"
              multiple
              :auto="true"
              accept="image/*,application/pdf,.doc,.docx,.xls,.xlsm,.xlsx,.csv"
              :maxFileSize="5000000"
              chooseLabel="Drop File here"
              ref="fileUpload"
              @select="onFileSelect"
              customUpload
              unstyled
              :pt="{
                root: {
                  class: `w-full px-3 py-3 !bg-[image:var(--p-fileinput-background)] dark:bg-[var(--p-fileinput-background)] text-base border border-[var(--border-input)] rounded focus:outline-none cursor-pointer flex flex-col gap-2 [&_div[aria-live='assertive']]:!hidden`,
                },
                basicContent: {
                  class:
                    'w-full *:flex *:flex-row-reverse *:justify-between gap-2 *:items-center',
                },
                input: { class: '!hidden' },
                chooseButton: {
                  class: 'w-full flex justify-between items-center',
                },
                pcChooseButton: { class: '!w-full' },
              }"
              class="w-full flex flex-col gap-2"
            >
              <template #chooseicon>
                <NuxtImg
                  :src="
                    $colorMode.preference == 'dark'
                      ? '/images/darkDownloadIcon.webp'
                      : '/images/downloadIcon.webp'
                  "
                  height="17"
                  width="16"
                  class="shrink-0"
                  loading="lazy"
                  format="webp"
                />
              </template>
            </FileUpload>

            <!-- Upload Progress -->
            <div
              v-if="isUploading"
              class="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700"
            >
              <div
                class="bg-[linear-gradient(95.99deg,#6C59B5_3.69%,#261640_96.65%)] h-2.5 rounded-full"
                :style="{ width: uploadProgress + '%' }"
              ></div>
            </div>

            <!-- Uploaded Files -->
            <ul v-if="form.uploaded_files.length" class="mt-4 space-y-3">
              <li
                v-for="(file, index) in form.uploaded_files"
                :key="index"
                class="group flex items-center justify-between p-4 bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg transition-colors duration-200"
              >
                <div class="flex items-center space-x-3 flex-1 min-w-0">
                  <!-- File Icon -->
                  <div
                    class="flex-shrink-0 w-10 h-10 bg-blue-100 dark:bg-blue-900 rounded-lg flex items-center justify-center"
                  >
                    <svg
                      class="w-5 h-5 dark:text-white"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                      ></path>
                    </svg>
                  </div>

                  <!-- File Info -->
                  <div class="flex-1 min-w-0">
                    <a
                      :href="file.full_url"
                      target="_blank"
                      class="block text-sm font-medium text-gray-900 dark:text-gray-100 hover:text-blue-600 dark:hover:text-blue-400 truncate underline decoration-transparent hover:decoration-current transition-colors duration-200"
                    >
                      {{ file.original_name }}
                    </a>
                    <p class="text-xs text-gray-500 dark:text-gray-400 mt-1">
                      Click to view file
                    </p>
                  </div>
                </div>

                <!-- Remove Button -->
                <button
                  type="button"
                  class="flex-shrink-0 ml-4 p-2 text-gray-400 hover:text-red-500 dark:text-gray-500 dark:hover:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-lg transition-all duration-200 group-hover:opacity-100 opacity-75"
                  @click="removeFile(index)"
                  title="Remove file"
                >
                  <svg
                    class="w-4 h-4"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                    ></path>
                  </svg>
                </button>
              </li>
            </ul>
          </div>

          <div class="flex max-xl:flex-col-reverse gap-2 items-center">
            <p class="text-sm">
              If you're a talented software professional and believe in working
              with us, feel free to
              <NuxtLink
                to="https://webreinvent.ohoapps.com/hrm/v4#/jobs"
                class="underline"
                >schedule an interview</NuxtLink
              >, or call us:
              <a href="tel:01203134356" class="underline"> 012 0313 4356</a> /
              <a href="tel:01203134356" class="underline"> +91 858 886 4948</a>
              .
            </p>
            <WrButton class="w-full min-w-max" type="submit"
              >Submit your request</WrButton
            >
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
